(function (angular) {
	angular.module('bizPartEngage').controller('modules.campaign', campaignController);
	angular.module('bizPartEngage').controller('modules.campaign.page', campaignPageController);

	campaignController.$inject = ["BizCampaignService", "$stateParams", "$rootScope", "$state",
		"bizContainerSettings", "bizCoreService"];
	campaignPageController.$inject = ["BizCampaignService", "$stateParams", "$rootScope", "$state", "$window",
		"bizContainerService", "container", "$scope"];

	function campaignController(campaignService, $stateParams, $rootScope, $state, bizContainerSettings, bizCoreService) {
        var vm = this;

        vm.GetCampaign = GetCampaign;
        vm.GoToCampaignStart = GoToCampaignStart;

        function GetCampaign() {
        	campaignService.GettingCampaign = campaignService.GetCampaign($stateParams.urlRewrite);
        	campaignService.GettingCampaign.then(GetCampaignCallback);

        	function GetCampaignCallback(response) {
        		vm.Campaign = response.data;
        		campaignService.Campaign = vm.Campaign;

        		bizContainerSettings.ContainerRefererType = "CAMPAIGN";
        		bizContainerSettings.ContainerRefererObjectId = vm.Campaign.Id;

        		if ($stateParams.referer)
        			bizCoreService.LogGenericObjectVisit("CAMPAIGN", vm.Campaign.Id, $stateParams.referer);

        		if (!$stateParams.pageUrlRewrite)
        			vm.GoToCampaignStart();
        	}
        }

        function GoToCampaignStart() {
        	var startPage = vm.Campaign.CampaignPages.GetItemByValue('CampaignPageTypeId', 1);
        	if (!startPage || $rootScope.LoggedInUser.Id > 0) {
        		startPage = vm.Campaign.CampaignPages.GetItemByValue('CampaignPageTypeId', 2);
        		if (!startPage) {
        			for (var i = 0; i < vm.Campaign.CampaignPages.length; i++) {
        				if (vm.Campaign.CampaignPages[i].CampaignPageTypeId > 1) {
        					startPage = vm.Campaign.CampaignPages[i];
        					break;
        				}
        			}
        		}
        	}
        	
        	if (startPage)
        		$state.go($rootScope.CurrentState.name + ".page", { pageUrlRewrite: startPage.UrlRewrite });
        	else
        		console.warn("No access to campaign pages");
        }

        $rootScope.Initialized.then(vm.GetCampaign);
    }

	function campaignPageController(campaignService, $stateParams, $rootScope, $state, $window, bizContainerService, container, $scope) {
    	var vm = this;

    	vm.GoToStart = GoToStart;
    	vm.GetCampaignPage = GetCampaignPage;
    	campaignService.ChangePage = ChangePage;

    	function ChangePage(pageId) {
    		if ($rootScope.LoggedInUser.Id > 0) {
    			var page = campaignService.Campaign.CampaignPages.GetItemByValue('Id', pageId);
    			if (page)
    				$state.go($rootScope.CurrentState.name, { pageUrlRewrite: page.UrlRewrite });
    		}
    		else
    			$window.location.reload();
    	}

    	function GoToStart() {
    		var startPage = campaignService.Campaign.CampaignPages.GetItemByValue('CampaignPageTypeId', 1);
    		if (!startPage || $rootScope.LoggedInUser.Id > 0) {
    			startPage = campaignService.Campaign.CampaignPages.GetItemByValue('CampaignPageTypeId', 2);
    			if (!startPage) {
    				for (var i = 0; i < campaignService.Campaign.CampaignPages.length; i++) {
    					if (campaignService.Campaign.CampaignPages[i].CampaignPageTypeId > 1) {
    						startPage = campaignService.Campaign.CampaignPages[i];
    						break;
    					}
    				}
    			}
    		}

    		if (startPage)
    			$state.go($rootScope.CurrentState.name, { pageUrlRewrite: startPage.UrlRewrite });
    	}

    	function GetCampaignPage() {
    		vm.GettingCampaignPage = true;

    		campaignService.GettingCampaign.then(PerformGetCampaignPage);

    		function PerformGetCampaignPage() {
    			if (!campaignService.Campaign)
    				return;

    			var page = campaignService.Campaign.CampaignPages.GetItemByValue("UrlRewrite", $stateParams.pageUrlRewrite);
    			if (!page) {
    				vm.GoToStart();
    				return;
    			}

    			campaignService.GetCampaignPage(page.Id).then(GetCampaignPageCallback);

    			function GetCampaignPageCallback(response) {
    				var page = response.data;
    				if (page && page.Container) {
    					page.Container = new container(page.Container);
    					vm.CampaignPage = page;
    				}

    				vm.GettingCampaignPage = false;
    			}
    		}
    	}

    	var destroyOnModuleFinish = $rootScope.$on('MODULE_FINISH', function (e, module) {
    		if (module.UseSettings) {
    			bizContainerService.SetContainerModuleInstanceFinished(module.Id).then(ModuleInstanceFinishedSuccess);
    		}
    	});

    	$scope.$on("$destroy", destroyOnModuleFinish);

    	$rootScope.Initialized.then(vm.GetCampaignPage);
    }
})(window.angular);
